module.exports = __webpack_public_path__ + "img/Paris-Academy.7addc243.png";